export default __webpack_public_path__ + "static/media/img9.bb002c47.png";